<template>
  <footer class="footer text-center py-4">
    <div class="container">
      <p class="mb-1">
        © {{ currentYear }} Axion Academy. All rights reserved.
      </p>

      <p class="text-pink mb-2">
        <i class="bi bi-telephone-fill me-2"></i>
        070 388 5876
      </p>

      <div class="social-icons">
        <a href="#" class="me-3"><i class="bi bi-facebook"></i></a>
        <a href="#" class="me-3"><i class="bi bi-instagram"></i></a>
        <a href="#"><i class="bi bi-youtube"></i></a>
      </div>
    </div>
  </footer>
</template>

<script setup>
const currentYear = new Date().getFullYear();
</script>

<style scoped>
.footer {
  background: black;
  color: #aaa;
  border-top: 1px solid rgba(255, 0, 204, 0.3);
}

.text-pink {
  color: #ff00cc;
}

.social-icons a {
  color: #aaa;
  font-size: 18px;
  transition: 0.3s;
}

.social-icons a:hover {
  color: #ff00cc;
  text-shadow: 0 0 8px #ff00cc;
}
</style>
